import PropTypes from "prop-types";
import React, { useEffect, useMemo } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Form } from "formsy-semantic-ui-react";
import { getVarietiesList } from "../../actions/Varieties";
import { Dropdown } from "semantic-ui-react";

const SelectVariety = ({
  actions: { getVarietiesList },
  varietiesList,
  isFetching,
  selectedCropID,
  required,
  error,
  minItemForSearch,
  onChange,
  native,
  ...extraProps
}) => {
  useEffect(() => {
    getVarietiesList();
  }, [getVarietiesList]);

  const filter = item => {
    if (!selectedCropID) return item;

    return item.crop.id === selectedCropID;
  };

  const options = useMemo(
    () =>
      varietiesList
        .filter(filter)
        .sort((c1, c2) => c1.name.localeCompare(c2.name))
        .map(content => ({
          key: content.id,
          text: content.name,
          value: content.id
        })),
    [varietiesList, selectedCropID]
  );

  useEffect(() => {
    if (required && options && options.length === 1) {
      onChange(null, { options, value: options[0].value });
    }
  }, [options]); // eslint-disable-line

  const props = {
    placeholder: "Select variety",
    fluid: true,
    ...extraProps,
    error,
    closeOnBlur: true,
    onChange,
    loading: isFetching,
    selection: true,
    required,
    search: options.length >= minItemForSearch,
    noResultsMessage: "Nothing was found",
    options
  };
  return native ? <Dropdown {...props} /> : <Form.Dropdown {...props} />;
};

SelectVariety.propTypes = {
  actions: PropTypes.object.isRequired,
  disabled: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  minItemForSearch: PropTypes.bool,
  native: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool.isRequired,
  selectedCropID: PropTypes.number,
  showArchived: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.array.isRequired,
    PropTypes.number.isRequired
  ]),
  varietiesList: PropTypes.array.isRequired
};

SelectVariety.defaultProps = {
  disabled: false,
  error: false,
  isFetching: false,
  minItemForSearch: 10,
  native: false,
  onChange: () => {},
  required: false,
  showArchived: false,
  value: [],
  varietiesList: []
};

const mapStateToProps = ({ varieties: { data, isFetching } }) => {
  return {
    varietiesList: data,
    isFetching
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      getVarietiesList
    },
    dispatch
  )
});

export default connect(mapStateToProps, mapDispatchToProps)(SelectVariety);
